import { useMemo, useState } from 'react';

import useSWR from 'swr';

import { PublicStrategy, TradedAssets, TradedAssetsPeriod } from '@/api/copy-trading/types';
import { fetchApiClientDestructData } from '@/api/fetchers/fetchApiClient';

export function useTradedAssets(strategy: PublicStrategy, initialData: TradedAssets = []) {
  const [period, setPeriod] = useState<TradedAssetsPeriod>(TradedAssetsPeriod.ALL);

  const params = useMemo(
    () => (period !== TradedAssetsPeriod.ALL ? new URLSearchParams({ period: period }).toString() : ''),
    [period],
  );

  const { data, error } = useSWR<TradedAssets | null>(
    `/v2/public/covesting/strategies/${strategy.strategyId}/trades/stats/?${params}`,
    fetchApiClientDestructData,
    {
      fallbackData: initialData,
    },
  );

  const tradedAssets: TradedAssets | null = useMemo(
    () => (!data ? null : data.filter((i) => i.usagePercent > 0)),
    [data],
  );

  return {
    setPeriod,
    period,
    tradedAssets,
    error,
  };
}
